import { STAGES } from "@/components/leads/leadMeta";

export const LeadFunnel = ({ stats, admin }) => {
  if (!stats) return null;
  const t = stats.total;
  const conv = t.total ? Math.round((100 * t.customer) / t.total) : 0;
  return (
    <div className="mb-6 space-y-4" data-testid="lead-funnel">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
        <div className="rounded-2xl bg-[#0F382C] p-4 text-white"><div className="text-[11px] uppercase tracking-wider text-white/60">All leads</div><div className="mt-1 font-mono text-3xl font-semibold" data-testid="funnel-total">{t.total}</div></div>
        {STAGES.map(([k, l]) => (
          <div key={k} className="rounded-2xl border border-[#E7E2D6] bg-white p-4"><div className="text-[11px] uppercase tracking-wider text-muted-foreground">{l}</div><div className="mt-1 font-mono text-3xl font-semibold" data-testid={`funnel-${k}`}>{t[k]}</div></div>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-3 text-sm"><span className="text-muted-foreground">Lead to customer conversion</span><span className="font-mono font-semibold text-[#D96B43]" data-testid="funnel-conversion">{conv}%</span></div>
      {admin && stats.reps.length > 0 && (
        <div className="overflow-x-auto rounded-2xl border border-[#E7E2D6] bg-white" data-testid="funnel-reps">
          <table className="w-full text-sm">
            <thead><tr className="border-b border-[#E7E2D6] text-left text-xs uppercase tracking-wider text-muted-foreground"><th className="p-3">Salesperson</th>{STAGES.map(([k, l]) => <th key={k} className="p-3 text-right">{l}</th>)}<th className="p-3 text-right">Total</th><th className="p-3 text-right">Conv.</th></tr></thead>
            <tbody>
              {stats.reps.map((r, i) => (
                <tr key={r.name} className="border-b border-[#F1EDE3] last:border-0" data-testid={`funnel-rep-${i}`}>
                  <td className="p-3 font-semibold">{r.name}</td>{STAGES.map(([k]) => <td key={k} className="p-3 text-right font-mono">{r[k]}</td>)}
                  <td className="p-3 text-right font-mono">{r.total}</td><td className="p-3 text-right font-mono text-[#D96B43]">{r.conversion}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
